<template>
    <div class="py-4 px-4 lg:px-8 mx-0 my-3 lg:mx-6">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="text-center">Karir</h1>
                    <p class="text-center">We are always looking for talented people to join our team. If you are interested in joining our team, please send your resume to <a :href="'mailto:' + setting.company_email">our email</a></p>
                </div>
            </div>
        </div>
    </div>
    <div class="py-4 px-4 lg:px-8 mx-0 my-3 lg:mx-6">
        <Card class="mt-3" v-for="model in models" v-bind:key="model.id">
            <template v-slot:title>
                <div class="flex align-items-center justify-content-between mb-0">
                    <h5>
                        <Link :href="/careers/+model.id">
                            {{ model.name }}
                        </Link>
                    </h5>
                    <h6>{{ model.updated_at }}</h6>
                </div>
            </template>
            <template v-slot:content>
                <p class="line-height-3 m-0"><span v-html="model.description"></span></p>
                <div class="align-items-right justify-content-center mt-3">
                    <Button @click="detail(model.id)" type="submit" label="Apply Now" class="p-3"></button>
                </div>
            </template>
        </Card>
    </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3';
import Card from 'primevue/card';
import DatatableService from "../../Services/DatatableService";
import Button from 'primevue/button';
export default {
    components: {
        Card,
        Link,
        Button,
    },
    data(){
        return{
            models: null,
            datatableService: null,
            setting: this.$page.props.setting.data,
        }
    },
    created(){
        this.datatableService = new DatatableService();
    },
    mounted(){
        this.loadData();
    },
    methods:{
        loadData() {
            this.datatableService
                .getData('api/careers')
                .then((data) => {
                    this.models = data.data;
                });
        },
        detail(id){
            this.$inertia.get('/careers/'+id);
        },
    },
}
</script>
